import ActionTypes from '../actionsTypes'

export const setCalcProject = (data: any) => {
  return {
    type: ActionTypes.SET_CALC_PROJECT,
    payload: {
      data,
    },
  }
}
